"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightCompanyEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const legacy_1 = require("../../../Form/Field/Select/legacy");
const FlightCompanyEditor = (props) => {
    const { value, items, onValue, error, modifiers } = props.field;
    const fieldProps = {
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:FlightCompany', defaultMessage: 'Company' })),
        modificators: modifiers,
        name: 'flightCompany',
        error,
        value: value === null || value === void 0 ? void 0 : value.id,
        onSelect: (item) => {
            const selectedItem = item === '' ? undefined : items === null || items === void 0 ? void 0 : items.filter(x => x.id === (item === null || item === void 0 ? void 0 : item.value)).pop();
            onValue(selectedItem);
        },
        items: ['', ...items.map((item) => ({ name: item.name, value: item.id }))],
    };
    return (react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...fieldProps }));
};
exports.FlightCompanyEditor = FlightCompanyEditor;
//# sourceMappingURL=FlightCompanyEditor.js.map